import React, { useState } from 'react';
import { Link } from 'gatsby';

import { Article, List, Item, Collaborators } from './style';
import WorkListThumbnail from '../WorkListThumbnail';

export default ({ work, label, collapsible }) => {
  const [activeThumbnailId, setActiveThumbnailId] = useState();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Article>
      <h2>
        {label}
        {collapsible ? (
          <span>
            {' '}
            <a
              onClick={() => {
                setIsOpen(!isOpen);
                return false;
              }}
              style={{ cursor: 'pointer' }}
            >
              [{isOpen ? 'close' : 'open'}]
            </a>
          </span>
        ) : null}
      </h2>
      {!collapsible || isOpen ? (
        <List>
          {work.map(({ id, title, slug, collaborators }) => (
            <Item key={id}>
              <Link
                to={`/work/${slug}`}
                onMouseMove={() => {
                  setActiveThumbnailId(id);
                }}
                onMouseLeave={() => {
                  setActiveThumbnailId();
                }}
              >
                {title}
                {collaborators ? (
                  <Collaborators>[{collaborators}]</Collaborators>
                ) : null}
              </Link>
            </Item>
          ))}
        </List>
      ) : null}
      <WorkListThumbnail work={work} activeId={activeThumbnailId} />
    </Article>
  );
};
